import { Component, ElementRef, Input } from '@angular/core'

import { VerticalInputContainerComponent } from '../vertical-input-container/vertical-input-container.component'

@Component({
    selector: 'col-horizontal-input-container',
    templateUrl: './horizontal-input-container.component.html',
    styles: [
        ':host { display: block; } ',
        '.microcopia { margin-top: 2px; color: #777777; font-size: 85%; font-style: italic; }'
    ]
})
export class HorizontalInputContainerComponent extends VerticalInputContainerComponent {
    @Input() labelClass = 'col-sm-3'
    @Input() inputClass = 'col-sm-9'
}



// WEBPACK FOOTER //
// ./src/app/common/horizontal-input-container/horizontal-input-container.component.ts